import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-700 bg-background-900/60 px-6 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-background-800 mb-4">
        <i className="ri-movie-2-line text-3xl text-secondary-400" />
      </div>
      <h3 className="font-heading text-lg font-bold text-foreground-100">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-400">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className="rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-foreground-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            {actionLabel}
          </button>
        ) : null}
        <Link
          to="/"
          className="rounded-md border border-background-700 px-5 py-2 text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-foreground-50 whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}